import { Input } from "antd";
import type { PasswordProps } from "antd/es/input";

const PasswordInput = (props: PasswordProps) => (
  <Input.Password visibilityToggle {...props} />
);

export default PasswordInput;
